import Model from './Model';

export default class SliderItem extends Model {
    readonly id: number;
    readonly casino_slider_id: number;
    readonly casino_game_category_translation_id: number;
    readonly category_name: string;
    readonly limit: number;

    constructor(data: any) {
        super();
        this.assignDataToProps(data, [
            'id',
            'casino_slider_id',
            'casino_game_category_translation_id',
            'limit',
            'category_name',
        ]);
    }
}
